import { render, staticRenderFns } from "./knowLogistics.vue?vue&type=template&id=f29ed13c"
import script from "./knowLogistics.vue?vue&type=script&lang=js"
export * from "./knowLogistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports